import { render, staticRenderFns } from "./ProfileQuickInfoSkeleton.vue?vue&type=template&id=a45f371a&scoped=true"
import script from "./ProfileQuickInfoSkeleton.vue?vue&type=script&lang=ts"
export * from "./ProfileQuickInfoSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ProfileQuickInfoSkeleton.vue?vue&type=style&index=0&id=a45f371a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45f371a",
  null
  
)

export default component.exports